<template>
   <div class="mainC">
        <ul class="list-group MobileHide">
            <b-spinner variant="success" label="Spinning" style="width: 3rem; height: 3rem; margin: auto; margin-top: 20px; margin-bottom: 20px;" v-if="spinning"></b-spinner>
            <div v-for="(tourid, j) in tourOrder" :key="j">
                <li class="list-group-item" v-if="tournaments[tourid].live && cookiesObject.token" style="background: #d6d6d6; color: black; line-height: 7px;"> 
                    <router-link id="router-link-league" :to="{ name: 'LeaguePageNav', params: { leagueId: tournaments[tourid].matches[0].tournament.id }}"> 
                        <img :src="leagueLogo + tournaments[tourid].matches[0].tournament.category.id" style="width: 17px; margin-right: 5px; margin-top: -2px;" alt=""/> 
                        {{tournaments[tourid].matches[0].tournament.name}} 
                    </router-link>
                </li>
                <li class="list-group-item" v-else-if="tournaments[tourid].live && !cookiesObject.token" style="background: #d6d6d6; color: black; line-height: 7px;" data-toggle="modal" data-target="#exampleModal"> 
                        <img :src="leagueLogo + tournaments[tourid].matches[0].tournament.category.id" style="width: 17px; margin-right: 5px; margin-top: -2px;" alt=""/> 
                        <span style="cursor: pointer;">{{tournaments[tourid].matches[0].tournament.name}}</span> 
                </li>
            <div v-for="(game, i) in tournaments[tourid].matches" :key="i"> 
            <div v-if="cookiesObject.token">
            <li class="list-group-item game" v-if="game.matchStatus.name == 'LIVE' || game.matchStatus.name == 'HT'">
            <div class="row">
            <router-link class="col" id="router-link" :to="{ name: 'MatchPagePar', params: { gameId: game.id } }">
            <div class="row">
            <div class="col-1 bodyElement">
              <p v-if="game.matchStatus.name == 'LIVE'">{{calculateMinutes(game.counterStartTime)}}<img src="@/assets/redLight.gif" style="width: 5px; position: absolute; margin-top: -4px;" alt="'"></p>   
              <p v-else-if="game.matchStatus.name == 'HT'">HT</p>      
              </div>
            <div class="col bodyElement">
                {{game.team1.name.slice(0,26)}}
            </div>
            <div class="col-1 bodyElement">
                {{game.currentScore}}
            </div>
            <div class="col bodyElement">
                {{game.team2.name.slice(0,26)}}
            </div>
                </div>
            </router-link>
             <div class="col-1 bodyElement">
            <div>
            <b-btn v-if="favsTe.some(fav => fav.id === game.id)" v-on:click="removeFavorite({value: game.id , type: match})" style="float: right; background: none; width: 5px; height: 5px; border: none;"> <img src="@/assets/blackStar.png" style="width: 15px; margin-top: -30px; margin-left: -10px;" alt=""> </b-btn> <b-btn v-else v-on:click="addToFavorites({value: game.id , type: match})" style="float: right; background: none; width: 5px; height: 5px; border: none;"> <img src="@/assets/favorite.png" style="width: 15px; margin-top: -30px; margin-left: -10px;" alt=""> </b-btn>           
            </div>
            </div>
        </div>
            </li>  
            </div>
            <div v-else data-toggle="modal" data-target="#exampleModal" style="cursor: pointer;">
            <li class="list-group-item game" v-if="game.matchStatus.name == 'LIVE' || game.matchStatus.name == 'HT'">
            <div class="row">
            <div class="col-1 bodyElement">
              <p v-if="game.matchStatus.name == 'LIVE'">{{calculateMinutes(game.counterStartTime)}}<img src="@/assets/redLight.gif" style="width: 5px; position: absolute; margin-top: -4px;" alt="'"></p>   
              <p v-else-if="game.matchStatus.name == 'HT'">HT</p>      
              </div>
            <div class="col bodyElement">
                {{game.team1.name.slice(0,26)}}
            </div>
            <div class="col-1 bodyElement">
                {{game.currentScore}}
            </div>
            <div class="col bodyElement">
                {{game.team2.name.slice(0,26)}}
            </div>
             <div class="col-1 bodyElement">
            <div>
            <b-btn style="float: right; background: none; width: 5px; height: 5px; border: none;"> <img src="@/assets/favorite.png" style="width: 15px; margin-top: -30px; margin-left: -10px;" alt=""> </b-btn>           
            </div>
            </div>
        </div>
            </li>  
            </div>
            </div>   
            </div>   
        </ul>
         <ul class="list-group MobileShow">
            <b-spinner variant="success" label="Spinning" style="width: 3rem; height: 3rem; margin: auto; margin-top: 20px; margin-bottom: 20px;" v-if="spinning"></b-spinner>
            <div v-for="(tourid, j) in tourOrder" :key="j"> 
                <li class="list-group-item" v-if="tournaments[tourid].live && cookiesObject.token" style="background: #d6d6d6; color: black; line-height: 7px;"> 
                    <router-link id="router-link-league" :to="{ name: 'LeaguePageNav', params: { leagueId: tournaments[tourid].matches[0].tournament.id } }"> 
                        <img :src="leagueLogo + tournaments[tourid].matches[0].tournament.category.id" style="width: 17px; margin-right: 5px; margin-top: -2px;" alt=""/> 
                        {{tournaments[tourid].matches[0].tournament.name}} 
                    </router-link>
                </li>
                <li class="list-group-item" v-else-if="tournaments[tourid].live && !cookiesObject.token" style="background: #d6d6d6; color: black; line-height: 7px;" v-b-modal.modal-multi-1> 
                        <img :src="leagueLogo + tournaments[tourid].matches[0].tournament.category.id" style="width: 17px; margin-right: 5px; margin-top: -2px;" alt=""/> 
                        <span style="cursor: pointer;">{{tournaments[tourid].matches[0].tournament.name}}</span> 
                </li>
                <div v-for="(game, i) in tournaments[tourid].matches" :key="i"> 
            <div v-if="cookiesObject.token">
            <li class="list-group-item game" v-if="game.matchStatus.name == 'LIVE' || game.matchStatus.name == 'HT'">
            <div class="row">
              <div class="col-1 bodyElement" style="margin-top: 10px;">
              <p v-if="game.matchStatus.name == 'LIVE'">{{calculateMinutes(game.counterStartTime)}}<img src="@/assets/redLight.gif" style="width: 5px; position: absolute; margin-top: -4px;" alt="'"></p>   
              <p v-else-if="game.matchStatus.name == 'HT'">HT</p>          
              </div>
            <router-link class="col" id="router-link" :to="{ name: 'MatchPagePar', params: { gameId: game.id } }">
            <div class="row">
            <div class="col" style="text-align: left; font-size: 14px; margin-top: 4px;">
            <div class="bodyElement" style="margin-bottom: 10px;">
                {{game.team1.name}}
            </div>
            <div class="bodyElement">
                {{game.team2.name}}
            </div>
            </div>
            <div class="col-1" style="margin-top: 4px;">
                 <div style="margin-bottom: 15px;">
            {{game.currentScore.slice(0,1)}} 
                </div>
                 <div>
            {{game.currentScore.slice(2,3)}}
                 </div>
            </div>
                </div>
            </router-link>
            <div class="col-1 bodyElement" style="margin-top: 4px;">
             <div>
            <b-btn v-if="favsTe.some(fav => fav.id === game.id)" v-on:click="removeFavorite({value: game.id , type: match})" style="float: right; background: none; width: 5px; height: 5px; border: none;"> <img src="@/assets/blackStar.png" style="width: 15px; margin-top: -30px; margin-left: -10px;" alt=""> </b-btn> <b-btn v-else v-on:click="addToFavorites({value: game.id , type: match})" style="float: right; background: none; width: 5px; height: 5px; border: none;"> <img src="@/assets/favorite.png" style="width: 15px; margin-top: -30px; margin-left: -10px;" alt=""> </b-btn>           
             </div> 
            </div>
        </div>
            </li>  
            </div>
            <div v-else v-b-modal.modal-multi-1> 
            <li class="list-group-item game" v-if="game.matchStatus.name == 'LIVE' || game.matchStatus.name == 'HT'">
            <div class="row">
              <div class="col-1 bodyElement" style="margin-top: 10px;">
              <p v-if="game.matchStatus.name == 'LIVE'">{{calculateMinutes(game.counterStartTime)}}<img src="@/assets/redLight.gif" style="width: 5px; position: absolute; margin-top: -4px;" alt="'"></p>   
              <p v-else-if="game.matchStatus.name == 'HT'">HT</p>          
              </div>
            <div class="col" style="text-align: left; font-size: 14px; margin-top: 4px;">
            <div class="bodyElement" style="margin-bottom: 10px;">
                {{game.team1.name}}
            </div>
            <div class="bodyElement">
                {{game.team2.name}}
            </div>
            </div>
            <div class="col-1" style="margin-top: 4px;">
                 <div style="margin-bottom: 15px;">
            {{game.currentScore.slice(0,1)}} 
                </div>
                 <div>
            {{game.currentScore.slice(2,3)}}
                 </div>
            </div>
            <div class="col-1 bodyElement" style="margin-top: 4px;">
            <div>
            <b-btn v-b-modal.modal-multi-1 style="float: right; background: none; width: 5px; height: 5px; border: none;"> <img src="@/assets/favorite.png" style="width: 15px; margin-top: -30px; margin-left: -10px;" alt=""> </b-btn>           
            </div>
        </div>
                </div>
            </li>  
            </div>
            </div>   
            </div>   
        </ul>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';

export default {
  name: 'AllGames',
  data(){
      return{
          games: [],
          gameId: '11886023',
          value: '',
          spinning: true,
          cookiesObject: '',
          leagueLogo: 'https://sportapi.zuniac.com/category/logo/',
          leagueId: '',
          leagueIden: '',
          TimeNow: '',
          match: 'match',
          tournaments: {},
          tourOrder: [],
      }
  },
  async mounted(){
      
    var cookiesObject = document.cookie.split(';').map(cookie => cookie.split('=')).reduce((accumulator, [key, value]) => ({...accumulator, [key.trim()]: decodeURIComponent(value)}),{});
    this.cookiesObject = cookiesObject;


     if (this.cookiesObject.token) {
    this.getArray();
    }

    this.getData();

    setInterval(() => {
            this.getData();
        }, 50000);

        this.calculateMinutes();

  },

    beforeDestroy() {
    clearInterval(this.setInterval);
  },

    methods:{
      ...mapActions(["getArray", "removeFavorite", "addToFavorites"]),
    async getData(){
     var offset = new Date().getTimezoneOffset();

    if (this.cookiesObject.token) {
        
    const res = await fetch(this.httpReq + '/sport/matches?date=' + this.getDate1() + '&portalId=' + this.cookiesObject.portalId + '&sportId=1&timezone=%2B'+ offset/-60 +'%3A00&token=' + this.cookiesObject.token);
    const data = await res.json();
    const games = data.matches;
    this.games = games;

    if (data.code == 200) {
       //everything is okay
    }
    else if (data.code == 401) {
      alert('Not Authorized, need to re sign in!')
         document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
    } else if(data.code == 404){
        alert('Token is not valid and portal id not provided')
        document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
    }
    else if(data.code == 500){
        alert('Server side error')
        document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
    } else {
        alert('service error')
        document.cookie = "token = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "langId = 1";
        document.cookie = "lang = en";
        document.cookie = "number = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        document.cookie = "portalId = ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        location.assign("/");
    }

    } else {

    const res = await fetch(this.httpReq + '/sport/matches?date=' + this.getDate1() + '&langId='+ this.cookiesObject.langId +'&portalId=' + this.cookiesObject.portalId + '&sportId=1&timezone=%2B'+ offset/-60 +'%3A00');
    const data = await res.json();
    const games = data.matches;
    this.games = games;   
    }

    const tournaments = {};
    const tourOrder = [];

    this.games.forEach((e) => {
        const tourid = e.tournament.id;

        if(typeof tournaments[tourid] === 'undefined') {
            tournaments[tourid] = {
                matches: [],
                live: false
            };
            tourOrder.push(tourid);
        }

        tournaments[tourid].matches.push(e);
        if(e.matchStatus.name == 'LIVE' || e.matchStatus.name == 'HT') {
            tournaments[tourid].live = true;
        }
    });
    
    this.tournaments = tournaments;
    this.tourOrder = tourOrder;

    this.spinning = false;

      },
         getDate1(){
        var dt = new Date();
        dt.setDate( dt.getDate() );
        var fdDate = dt.getDate();
        var fdMonth =(dt.getMonth() + 1);
        var fdYear = dt.getFullYear();   

        if (fdMonth.toString().length == 1) {
                  fdMonth = '0' + fdMonth; 
                } 
                if (fdDate.toString().length == 1) {
                  fdDate = '0' + fdDate; 
                } 
         
        var fd =  fdYear + '-' + fdMonth + '-' +fdDate;
        return fd;
    },     
        calculateMinutes(value){
       if (value == null) {
            return 'LIVE';
        } else{

        var startDate = new Date(value.replace(' ', 'T'));
        var endDate   =  Date.now();
        var difference = ((endDate - startDate) / 1000) / 60;

        if (difference < 0) {
            difference = difference + 240;
        }

        return parseInt(difference);
        }

         },

    },  
  components: {
  },
  props: {
    
  },
  computed: { 
      ...mapGetters(['favsTe','httpReq']),
    },

  watch: {
  },
}

</script>

<style scoped>
.mainC{
    margin-top: 2px;
}
#router-link{
    color: black;
    text-decoration: none;
}

.container{
    margin-top: 12px;
}
#router-link-league{
    color: black;
    text-decoration: none;
}

li{
   line-height:5px;
   border-radius: 0px !important;
   font-size: 12px;
}
.LeagueName{
    margin-bottom: 10px;
}

.header{
    background: #d6d6d6;
    color: white;
}

.bodyElement{
    padding: 0;
    height: 8px;
}

.game{
    text-align: center;
}
.game :hover{
    color: #309a3d;
}


@media only screen and (max-width: 770px) {
  body{
    background: #212529;
  }
  .MobileHide {
    display: none;
  }
}

@media only screen and (min-width: 770px) {
  .MobileShow {
    display: none;
  }
}
</style>
